"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LifeCycleButton = function LifeCycleButton(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color;
  return /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    color: color,
    style: {
      margin: 12
    },
    onClick: onClick
  }, label);
};

var TicketActions = function TicketActions(_ref2) {
  var onAccept = _ref2.onAccept,
      canAccept = _ref2.canAccept,
      onReject = _ref2.onReject,
      canReject = _ref2.canReject,
      onApprove = _ref2.onApprove,
      canRetry = _ref2.canRetry,
      onRetry = _ref2.onRetry,
      canApprove = _ref2.canApprove,
      onReview = _ref2.onReview,
      canReview = _ref2.canReview,
      onValidate = _ref2.onValidate,
      canValidate = _ref2.canValidate,
      onCancel = _ref2.onCancel,
      canCancel = _ref2.canCancel,
      onPublishProvisional = _ref2.onPublishProvisional,
      canPublishProvisional = _ref2.canPublishProvisional,
      onPublish = _ref2.onPublish,
      canPublish = _ref2.canPublish,
      labels = _ref2.labels;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center"
  }, canAccept ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onAccept();
    },
    label: labels.accept
  }) : '', canReject ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onReject();
    },
    label: labels.reject,
    color: "secondary"
  }) : '', canApprove ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onApprove();
    },
    label: labels.approve
  }) : '', canRetry ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onRetry();
    },
    label: labels.retry
  }) : '', canReview ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onReview();
    },
    label: labels.review
  }) : '', canValidate ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onValidate();
    },
    label: labels.validate
  }) : '', canCancel ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onCancel();
    },
    label: labels.cancel,
    color: "secondary"
  }) : '', canPublishProvisional ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onPublishProvisional();
    },
    label: labels.publishProvisional
  }) : '', canPublish ? /*#__PURE__*/_react["default"].createElement(LifeCycleButton, {
    onClick: function onClick() {
      return onPublish();
    },
    label: labels.publish
  }) : '');
};

TicketActions.propTypes = {
  canAccept: _propTypes["default"].bool,
  canApprove: _propTypes["default"].bool,
  canCancel: _propTypes["default"].bool,
  canPublish: _propTypes["default"].bool,
  canPublishProvisional: _propTypes["default"].bool,
  canReject: _propTypes["default"].bool,
  canRetry: _propTypes["default"].bool,
  canReview: _propTypes["default"].bool,
  canValidate: _propTypes["default"].bool,
  labels: _propTypes["default"].object.isRequired,
  onAccept: _propTypes["default"].func,
  onApprove: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  onPublish: _propTypes["default"].func,
  onPublishProvisional: _propTypes["default"].func,
  onReject: _propTypes["default"].func,
  onRetry: _propTypes["default"].func,
  onReview: _propTypes["default"].func,
  onValidate: _propTypes["default"].func,
  ticket: _propTypes["default"].object,
  user: _propTypes["default"].object
};
var _default = TicketActions;
exports["default"] = _default;